import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue
} from './ui/select';

export default function ItemsSortComponent({
    setSortBy,
    sortBy
}) {
    return (
        <Select value={sortBy} onValueChange={(value) => setSortBy(value)}>
            <SelectTrigger className="w-[140px] bg-card border-border">
                <SelectValue />
            </SelectTrigger>
            <SelectContent>
                <SelectItem value="desc">Newest</SelectItem>
                <SelectItem value="asc">Oldest</SelectItem>
            </SelectContent>
        </Select>
    );
}
